import { __assign } from "tslib";
import { AsyncState, IAction, IAsyncState } from "../action";
import { actionTypes } from "../actions";
var initialState = {
    dataModelNames: new AsyncState(),
    selectedDataModel: '',
};
export function dataModelNames(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.loadScopeNames:
            if (action.payload) {
                return state;
            }
            return initialState;
        case actionTypes.loadDataModelNames:
            return __assign(__assign({}, initialState), { dataModelNames: __assign(__assign({}, state.dataModelNames), { isFetching: true, timestamp: new Date() }) });
        case actionTypes.dataModelNamesLoaded:
            return __assign(__assign({}, state), { dataModelNames: __assign(__assign({}, state.dataModelNames), action.payload) });
        case actionTypes.loadDataModelNodes:
            return __assign(__assign({}, state), { selectedDataModel: action.payload.selectedDataModel });
        default:
            return state;
    }
}
